"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    authenticityToken() {
        const token = document.querySelector('meta[name="csrf-token"]');
        if (token instanceof HTMLMetaElement) {
            return token.content;
        }
        return null;
    },
    authenticityHeaders(otherHeaders = {}) {
        return Object.assign(otherHeaders, {
            'X-CSRF-Token': this.authenticityToken(),
            'X-Requested-With': 'XMLHttpRequest',
        });
    },
};
